import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const u = localStorage.getItem("lp_user");
    return u ? JSON.parse(u) : null;
  });
  const [loading, setLoading] = useState(false);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("lp_token", data.token);
      localStorage.setItem("lp_user", JSON.stringify(data.user));
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      const detail = e.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : "Error al iniciar sesión";
      return { ok: false, error: msg };
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) { /* ignore */ }
    localStorage.removeItem("lp_token");
    localStorage.removeItem("lp_user");
    setUser(null);
    window.location.href = "/login";
  };

  // Allow external components (AuthCallback) to set the user after OAuth
  const setUserExternal = (u) => setUser(u);

  useEffect(() => {
    if (user && localStorage.getItem("lp_token")) {
      api.get("/auth/me").then(({ data }) => {
        // Refrescar user (incluye permissions actualizadas)
        localStorage.setItem("lp_user", JSON.stringify(data));
        setUser(data);
      }).catch(() => logout());
    }
    // eslint-disable-next-line
  }, []);

  return (
    <AuthCtx.Provider value={{ user, login, logout, loading, setUserExternal }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
